<template>
    <div class="markdown-section">
    <article class="box">
        <section-header
          :label="label" :editing="editing" :message="error"
          @edit="edit" @save="validate" @cancel="cancel"
        ></section-header>
        <html-view v-if="!editing" :content="editableValue || placeholder"></html-view>
        <text-area v-else ref="markdownText" class="profileEditor" rows="3" v-model="editableValue"></text-area>
    </article>
    </div>
</template>

<script>
import HtmlView from '@/components/Controls/HTMLView'
import TextArea from '@/components/Inputs/QuillEditor'
import SectionHeader from './SectionHeader'

import componentState from '@/mixins/component-state'
import state from '../../state'

export default {
  mixins: [componentState],
  props: ['label', 'field', 'value', 'placeholder', 'allowBlank'],
  components: {
    SectionHeader,
    TextArea,
    HtmlView
  },
  data: function () {
    return {
      editing: false,
      editableValue: '',
      error: ''
    }
  },
  computed: {
    importData: function () {
      return this._get(state.importData, null)
    }
  },
  mounted: function () {
    this.setDefaultValue()
  },
  watch: {
    value: function () {
      this.setDefaultValue()
    },
    importData: function (data) {
      if (data && data[this.field]) {
        this.import()
      }
    }
  },
  methods: {
    setDefaultValue: function () {
      this.editableValue = this.value
    },
    edit: function () {
      this.editing = true
      this.$emit('startEdit')
      this.error = ''
    },
    cancel: function () {
      this.setDefaultValue()
      this.$emit('stopEdit')
      this.editing = false
    },
    validate: function () {
      if (this.value === this.editableValue) {
        return this.cancel()
      }

      if (!this.allowBlank && this.editableValue === '') {
        this.error = 'Field cannot be blank'
        return
      }

      this.save()
    },
    save: function () {
      const data = {}
      data[this.field] = this.editableValue

      this._callback(state.callbacks.save.profile, data).then(() => {
        this.editing = false
      }).catch((error) => {
        this.error = error.message
      })
    },
    import: function () {
      this.editableValue = this.importData[this.field]
      this.edit()
    }
  }
}
</script>

<style lang="scss" scoped>
.markdown-section{
  padding: 1rem 0;
}
</style>
